import { SVGProps } from 'react';

import theme from '@styles/theme';

export const WarningAlertTriangleIcon = ({
  width = '24',
  height = '24',
  fill = theme.palette.color[0],
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill={fill}
      fillRule='evenodd'
      d='M12.866 4.125a1 1 0 0 0-1.732 0l-8.66 15a1 1 0 0 0 .866 1.5h17.32a1 1 0 0 0 .866-1.5zM12 9.315a.9.9 0 0 1 .9.9v3.977a.9.9 0 1 1-1.8 0v-3.977a.9.9 0 0 1 .9-.9m1 8.046a1 1 0 1 1-2 0 1 1 0 0 1 2 0'
      clipRule='evenodd'
    ></path>
  </svg>
);
